import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100%',
		padding: spacing.lg,
	},
	layout: {
		display: 'flex',
		flex: 1,
		gap: spacing.lg,
		alignItems: 'flex-start',
	},
	formSection: {
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		flex: '0 0 500px',
		padding: spacing.lg,
	},
	summarySection: {
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		padding: spacing.lg,
		position: 'sticky',
		top: spacing.lg,
	},
	sectionTitle: {
		borderBottom: `1px solid ${colors.border.light}`,
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: 600,
		marginBottom: 20,
		marginTop: 0,
		paddingBottom: 12,
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: spacing.md,
	},
	formRow: {
		display: 'flex',
		gap: spacing.md,
	},
	formGroupHalf: {
		flex: 1,
	},
	label: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
		marginBottom: spacing.sm,
	},
	input: {
		border: common.border,
		borderRadius: 4,
		fontSize: typography.fontSizes.sm,
		padding: '10px 12px',
		width: '100%',
	},
	paymentMethodToggle: {
		display: 'flex',
		gap: 0,
		marginBottom: 20,
	},
	paymentMethodButton: {
		flex: 1,
		padding: '12px 16px',
		border: common.border,
		background: colors.background.light,
		cursor: 'pointer',
		fontSize: typography.fontSizes.sm,
		fontWeight: 500,
		transition: 'all 0.2s ease',
		':first-child': {
			borderRadius: '4px 0 0 4px',
			borderRight: 'none',
		},
		':last-child': {
			borderRadius: '0 4px 4px 0',
		},
	},
	paymentMethodButtonActive: {
		background: colors.hover.main,
		borderColor: colors.hover.main,
		color: colors.background.light,
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
		marginTop: spacing.lg,
		paddingTop: spacing.md,
		borderTop: `1px solid ${colors.border.light}`,
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		justifyContent: 'center',
		padding: spacing.xxxl,
	},
	errorContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: spacing.xxxl,
		textAlign: 'center',
	},
	summaryContent: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 12,
		overflowY: 'auto',
	},
	planInfo: {
		borderBottom: `1px solid ${colors.border.light}`,
		marginBottom: spacing.sm,
		paddingBottom: 12,
	},
	planName: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		fontWeight: 600,
		marginBottom: spacing.xs,
	},
	planDetails: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	breakdown: {
		borderBottom: `2px solid ${colors.border.main}`,
		marginBottom: spacing.md,
		paddingBottom: spacing.md,
	},
	breakdownRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '8px 0',
	},
	breakdownLabel: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
	},
	breakdownValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
	},
	monthlyNote: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		fontWeight: 'normal',
		marginRight: spacing.xs,
	},
	summaryRow: {
		alignItems: 'center',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		justifyContent: 'space-between',
		padding: '4px 0',
	},
	summaryLabel: {
		color: colors.text.light,
	},
	summaryValue: {
		color: colors.text.main,
		fontWeight: 500,
	},
	totalRow: {
		alignItems: 'center',
		background: colors.background.main,
		borderRadius: common.borderRadius,
		display: 'flex',
		fontSize: typography.fontSizes.lg,
		fontWeight: 600,
		justifyContent: 'space-between',
		marginTop: spacing.md,
		padding: spacing.md,
	},
	splitBillingNote: {
		background: colors.success.subtle.light,
		border: `1px solid ${colors.success.subtle.main}`,
		borderRadius: common.borderRadius,
		color: colors.success.subtle.dark,
		fontSize: 13,
		fontWeight: 600,
		marginTop: 12,
		padding: 12,
		textAlign: 'center',
	},
	divider: {
		borderTop: `1px solid ${colors.border.light}`,
		margin: '12px 0',
	},
	addonsSection: {
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.sm,
	},
	addonsTitle: {
		color: colors.text.light,
		fontWeight: 500,
		marginBottom: spacing.sm,
	},
	addonsList: {
		listStyle: 'disc',
		marginLeft: 20,
		marginTop: spacing.xs,
	},
	addonsItem: {
		color: colors.text.main,
		marginBottom: spacing.xs,
	},
	chargifyFormContainer: {
		marginBottom: spacing.md,
	},
	chargifyFormWrapper: {
		minHeight: 250,
		position: 'relative',
	},
	chargifyLoadingOverlay: {
		alignItems: 'center',
		background: colors.background.main,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		height: '100%',
		justifyContent: 'center',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 1,
	},
	chargifyForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		transition: 'opacity 0.2s ease',
	},
	chargifyField: {
		minHeight: 70,
		width: '100%',
	},
	chargifyError: {
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		color: colors.danger.main,
		marginBottom: spacing.md,
		padding: 12,
	},
	invoiceSection: {
		background: colors.background.main,
		borderRadius: common.borderRadius,
		marginBottom: spacing.md,
		padding: spacing.md,
	},
	invoiceNote: {
		color: colors.text.light,
		fontSize: 13,
		marginTop: spacing.sm,
	},
	offerBadge: {
		background: colors.info.light,
		borderRadius: 4,
		color: colors.primary.main,
		display: 'inline-block',
		fontSize: typography.fontSizes.xs,
		fontWeight: 500,
		marginTop: spacing.xs,
		padding: '4px 8px',
	},
});
